/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { errorToObject, v2 } from "@prftesp/cle-logger";
import errorCodes from "../../../../utility/errorCodes";
import { listScheduledReports, updateScheduledReports } from "../../services/ReportService";
import { scheduledReportsActions } from "./reducer";

const COMPONENT_NAME = "Admin settingsManager/context/statusAlerts/actions";

export const fetchScheduledReportsList = async (dispatch) => {
	try {
		dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_LIST_GET });
		const response = await listScheduledReports();
		dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_LIST_GET_SUCCESS, payload: response.scheduledReports });
	} catch (error) {
		v2.error(`Error while fetching scheduled report.`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SAVE_SCHEDULED_REPORT_ERROR,
		});
		dispatch({
			type: scheduledReportsActions.SCHEDULED_REPORT_LIST_GET_ERROR,
			error: "Failed to load scheduled reports.",
		});
	}
};

export const saveRemoteScheduledReportsList = async (dispatch, reportUpdates) => {
	try {
		dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE });
		const data = await updateScheduledReports(reportUpdates);
		if (data.exceptions.length > 0) {
			dispatch({
				type: scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_ERROR,
				error: "Failed to save scheduled reports.",
			});
		}
		dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_SUCCESS });
	} catch (error) {
		v2.error(`Error while updating scheduled reports`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.SAVE_SCHEDULED_REPORT_ERROR,
		});
		dispatch({
			type: scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_ERROR,
			error: "Failed to save scheduled reports.",
		});
	}
};

export const clearScheduledReportsChanges = (dispatch) => {
	dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_LIST_CLEAR_CHANGES });
};

export const updateScheduledReportsChanges = (dispatch, scheduledReports) => {
	dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_LIST_UPDATE_CHANGES, payload: scheduledReports });
};

export const updateScheduledReportAction = (dispatch, scheduledReport, index) => {
	dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_UPDATE, payload: scheduledReport, index });
};

export const removeScheduledReportAction = (dispatch, reportId, index) => {
	dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_REMOVE, payload: reportId, index });
};

export const addScheduledReportAction = (dispatch, scheduledReports) => {
	dispatch({ type: scheduledReportsActions.SCHEDULED_REPORT_ADD_NEW, payload: scheduledReports });
};
